import { useTranslation } from 'react-i18next'
import styled from 'styled-components'
import CloseButton from '@/components/close-button'
import { CrossedOutEye, WarningLarge } from '@/components/icons'
import { createModal, useModalize } from '@/components/modalize'
import { breakpoints, colors, fontWeights } from '@/styles'

const Wrapper = styled.div`
  background: ${colors.white};
  position: relative;
  display: flex;
  flex-direction: column;
  align-items: center;
  flex-shrink: 0;
  height: 100%;
  max-height: 98vh;
  padding: 40px;

  @media screen and (max-width: ${breakpoints.ipadMiniMax}) {
    padding: 32px;
  }
`

const StyledEye = styled(CrossedOutEye)`
  > path {
    fill: ${colors.white};
  }
  margin-right: 4px;
`

const Title = styled.h3`
  display: flex;
  align-items: center;
  font-size: 24px;
  font-weight: ${fontWeights.bold};
  line-height: 32px;
  margin: 24px 0 8px;
  width: 100%;
  text-align: center;
  justify-content: center;
`

const Text = styled.p`
  margin-bottom: 26px;
  color: ${colors.grey48};
  font-size: 16px;
  line-height: 24px;
  text-align: center;
`
const ButtonContainer = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr;
  grid-gap: 8px;
  width: 100%;
  max-width: 370px;
  height: 100%;
  margin: 0 auto;
`

const Button = styled.button`
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 16px 20px;
  width: 100%;
  height: 48px;
  max-width: 176px;
  background-color: ${colors.white};
  color: ${colors.blue16};
  border: 1.5px solid ${colors.grey88};
  border-radius: 6px;
  flex-grow: 1;
  font-weight: ${fontWeights.bold};
  cursor: pointer;

  :hover {
    opacity: 0.6;
  }
`

const HideButton = styled(Button)`
  background-color: ${colors.blue16};
  color: ${colors.white};
  box-shadow: 0px 16px 32px -8px rgba(0, 0, 0, 0.15);
`

const ListingHiddenModal = ({ handleUnhide }) => {
  const { close } = useModalize()
  const { t } = useTranslation()

  const unhide = async () => {
    await handleUnhide()
    close()
  }

  return (
    <Wrapper>
      <CloseButton width={14} height={14} top={18} right={18} onClick={close} />
      <WarningLarge />
      <Title>
        {t(
          'l.listing.view.listing_hidden_modal.title',
          'This listing is hidden from public search.'
        )}
      </Title>
      <Text>
        {t('l.listing.view.listing_hidden_modal.text', 'Do you want to unhide this listing?')}
      </Text>
      <ButtonContainer>
        <Button onClick={close}>{t('common.cancel', 'Cancel')}</Button>
        <HideButton onClick={unhide}>
          <StyledEye />
          {t('l.chat.view.unhide.button', 'Unhide')}
        </HideButton>
      </ButtonContainer>
    </Wrapper>
  )
}

ListingHiddenModal.displayName = 'ListingHiddenModal'

export const showListingHiddenModal = createModal(ListingHiddenModal, {
  width: 'auto',
  maxWidth: '440px',
  flexGrow: true,
  border: '1px solid #d8d8d8',
  tabletFullscreen: true
})
